<template>
  <div v-if="isQrFormat" class="d-flex justify-content-center align-items-center vh-100">
    <img v-if="match" :src="qrCodeUrl" alt="QR Code" />
    <div v-else class="text-center text-muted">試合が見つかりません</div>
  </div>
  <div v-else class="container mt-3">
    <div v-if="loading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else-if="match" class="d-flex justify-content-center">
      <MatchCardComponent :match="match" />
    </div>
    <div v-else class="text-center text-muted">
      試合が見つかりません
    </div>
    <FooterComponent @doFetch="doFetch" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { getDatabase, ref as fbRef, get } from 'firebase/database'
import MatchCardComponent from '@/components/MatchCardComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

const route = useRoute()
const db = getDatabase()

const match = ref(null)
const loading = ref(true)

const isQrFormat = computed(() => route.query.format === 'qr')

const qrCodeUrl = computed(() => {
  const matchId = route.params.match_id
  return `https://api.excelapi.org/other/qrcode?text=${matchId}&size=100`
})

onMounted(async () => {
  const matchId = route.params.match_id
  try {
    const snapshot = await get(fbRef(db, `/2026-summer/matches/${matchId}`))
    if (snapshot.exists()) {
      match.value = snapshot.val()
    }
  } catch (error) {
    console.error('試合データの取得エラー:', error)
  } finally {
    loading.value = false
  }
})

const doFetch = () => {
  // データの再取得ロジックが必要な場合はここに実装
}
</script>
